import { isEqual } from 'lodash';

import { Action } from '../actions';
import {
    CHANGE_TAG_CLOUD_TARGETING_VALUE,
    CLOSE_TAG_CLOUD_TARGETING,
    OPEN_TAG_CLOUD_TARGETING,
    SAVE_TAG_CLOUD_TARGETING,
    TagCloudTargetingCloseAction,
    TagCloudTargetingOpenAction,
    TagCloudTargetingSaveAction,
    TagCloudTargetingsUpdateAction,
    TagCloudTargetingValueChangeAction,
    UPDATE_TAG_CLOUD_TARGETINGS
} from '../actions/tagCloudTargeting';
import { getUniqueArrayOfTargetingValues } from '../service/TagCloudTargetingHelper/TagCloudTargetingHelper';
import { State } from '../typings/state';
import { TagCloudTargetingsState } from '../typings/tagCloudTargeting';

const openTagCloudTargeting = (
    state: TagCloudTargetingsState,
    action: TagCloudTargetingOpenAction
): TagCloudTargetingsState => {
    return {
        ...state,
        [action.editorId]: {
            ...state[action.editorId],
            isOpen: true
        }
    };
};

const closeTagCloudTargeting = (
    state: TagCloudTargetingsState,
    action: TagCloudTargetingCloseAction
): TagCloudTargetingsState => {
    const { editorId } = action;
    const savedValue = state[editorId].savedValue || {
        includedValue: [],
        excludedValue: []
    };

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            ...savedValue,
            isOpen: false
        }
    };
};

const saveTagCloudTargeting = (
    state: TagCloudTargetingsState,
    action: TagCloudTargetingSaveAction
): TagCloudTargetingsState => {
    const { editorId, onTargetingSave } = action;

    const includedValue = onTargetingSave
        ? onTargetingSave(state[editorId].includedValue)
        : state[editorId].includedValue;
    const excludedValue = onTargetingSave
        ? onTargetingSave(state[editorId].excludedValue)
        : state[editorId].excludedValue;

    const savedValue = {
        includedValue,
        excludedValue
    };

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            ...savedValue,
            isOpen: false,
            savedValue
        }
    };
};

const changeTagCloudTargetingValue = (
    state: TagCloudTargetingsState,
    action: TagCloudTargetingValueChangeAction
): TagCloudTargetingsState => {
    const { value, editorId } = action;
    const { includedValue, excludedValue } = value;

    return {
        ...state,
        [editorId]: {
            ...state[editorId],
            includedValue: isEqual(state[editorId].includedValue, includedValue)
                ? state[editorId].includedValue
                : getUniqueArrayOfTargetingValues(includedValue),
            excludedValue: isEqual(state[editorId].excludedValue, excludedValue)
                ? state[editorId].excludedValue
                : getUniqueArrayOfTargetingValues(excludedValue)
        }
    };
};

const updateTagCloudTargetings = (
    state: TagCloudTargetingsState,
    action: TagCloudTargetingsUpdateAction
): TagCloudTargetingsState => {
    return {
        ...state,
        ...action.editors
    };
};

export const tagCloudTargeting = (
    state: TagCloudTargetingsState = {},
    action: Action,
    fullState: State
): TagCloudTargetingsState => {
    switch (action.type) {
        case OPEN_TAG_CLOUD_TARGETING:
            return openTagCloudTargeting(state, action);
        case CLOSE_TAG_CLOUD_TARGETING:
            return closeTagCloudTargeting(state, action);
        case SAVE_TAG_CLOUD_TARGETING:
            return saveTagCloudTargeting(state, action);
        case CHANGE_TAG_CLOUD_TARGETING_VALUE:
            return changeTagCloudTargetingValue(state, action);
        case UPDATE_TAG_CLOUD_TARGETINGS:
            return updateTagCloudTargetings(state, action);
        default:
            return state;
    }
};
